import { DarePlatform, Platform } from 'root/src/shared/@types/platforms';
export function getDarePlatforms(dare) {
    var _a;
    const platformSet = new Set((_a = dare === null || dare === void 0 ? void 0 : dare.platforms) === null || _a === void 0 ? void 0 : _a.map(platform => platform));
    return Array.from(platformSet);
}
/**
 * Get the platforms that the dares are available on.
 * @param dares
 */
export function getDropDarePlatforms(dares) {
    const platformSet = dares.reduce((acc, dare) => {
        if (dare.disabled) {
            return acc;
        }
        const darePlatform = getDarePlatforms(dare);
        darePlatform.forEach(platform => acc.add(platform));
        return acc;
    }, new Set());
    return Array.from(platformSet);
}
/**
 * Get the difficulty levels of the dares.
 * @param dares
 */
export function getDropDareDifficultyLevels(dares) {
    const difficultySet = dares.reduce((acc, dare) => {
        acc.add(dare.level);
        return acc;
    }, new Set());
    return Array.from(difficultySet);
}
/**
 * Get the battle pass ids of the dares.
 * @param dares
 */
export function getDropDareBattlePassIds(dares) {
    const battlePassIds = dares.reduce((acc, dare) => {
        if (dare.battlePass) {
            acc.add(dare.battlePass.id);
        }
        return acc;
    }, new Set());
    return Array.from(battlePassIds);
}
/**
 * Check if the dare is available on all platforms.
 * @param dare
 */
export function isDareAnyPlatform(dare) {
    return Object.values(DarePlatform).keys.length === dare.platforms.length;
}
/**
 * Get the platform classification for the given dare platform.
 * @example getClassifiedDarePlatform(DarePlatform.Twitch); // Platform.Twitch
 * @example getClassifiedDarePlatform(DarePlatform.YouTube); // Platform.YouTube
 * @example getClassifiedDarePlatform(DarePlatform.TikTok); // Platform.TikTok
 * @example getClassifiedDarePlatform(DarePlatform.YouTubeShorts); // Platform.YouTube
 * @param darePlatform
 */
export function getClassifiedDarePlatform(darePlatform) {
    switch (darePlatform) {
        case DarePlatform.Twitch:
            return Platform.Twitch;
        case DarePlatform.YouTube:
            return Platform.YouTube;
        case DarePlatform.TikTok:
            return Platform.TikTok;
        case DarePlatform.YouTubeShorts:
            return Platform.YouTube;
        default:
            return undefined;
    }
}
